import React from "react";
import { Box } from "@chakra-ui/react";

export default function Admin() {
  return (
    <Box max-height="100vh" overflow="hidden">
      <img src="https://i.imgur.com/tfo5wJM.png" alt="Admin Page" />
    </Box>
  );
}
